import { BROADCAST_SOURCE_TO_KNOCK } from 'actions/Types';

export default updatedKnock => {
  return dispatch => {
    const action = {
      type: BROADCAST_SOURCE_TO_KNOCK,
      payload: { ...updatedKnock }
    };

    dispatch(action);
  };
};
